import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const ShelfLifeApi = {
  // Create ShelfLife Api
  CreateShelfLife: (data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/shelf-lives`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Put ShelfLife Api
  PutShelfLife: (ShelfLifeID, data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .put(`/shelf-lives/${ShelfLifeID}`, JSON.stringify(jsonData), {
        headers: getHeaders(),
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List ShelfLife Api
  ListShelfLife: (page, limit) => {
    const url = `/shelf-lives?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Shelf Life Api
  SingleShelfLife: (ShelfLifeID) => {
    const url = `/shelf-lives/${ShelfLifeID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Shelf Life Api
  DeleteShelfLife: (ShelfLifeID) => {
    const url = `/shelf-lives/${ShelfLifeID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .delete(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default ShelfLifeApi;
